var template = require('./index.html');
/**
 * directives.slider Module
 *
 * Description
 */
var app = angular.module('directives.sliderServicesAll');
app.directive('sliderServicesAll', [function () {
    return {
        templateUrl: './app/directives/sliderServicesAll/index.html',
        controller: [
            '$scope',
            'Services',
            function ($scope, Services) {
                $scope.Services = Services;
                var Slider = {
                    serviceWidth: 185,
                    itemCounts: 12,
                    currentService: 0,
                    service: []
                };

                $scope.Slider = Slider;
            }]
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderServicesAll/directive.js
 ** module id = 229
 ** module chunks = 1
 **/